import React, { useEffect, useState } from 'react';
import moment from 'moment';
import SeasonPayouts from './SeasonPayouts';

import api from '../../utils/api';

const Season = ({ season: seasonData, yearName, loadPayouts }) => {
    const [payouts, updatePayouts] = useState([]);

    useEffect(() => {
        if (loadPayouts) {
            api.get(`/api/v1/history/payouts/year/${yearName}`).then(({data: payouts}) => {
                updatePayouts(payouts);
            }).catch((err) => {
                console.error(err);
            });
        }
    }, []);
    const isWinner = (game, player) => {
        return Object.keys(game).filter( eachPlayer => {
            return game[player] > game[eachPlayer] 
        }).length;
    };
    
    const getGameComponentFromGames = (games, props, teamData) => {
        return games.map((game, index) => {
            return <div key={`${Object.keys(game).join('-')}-${yearName}}`} className="bracket-matchup">
                {(Object.keys(game).map(player => {
                    const _isWinner = isWinner(game, player);
                    return <div 
                        key={`${player}-${index}`}
                        className={`bracket-team ${_isWinner ? 'bracket-winner' : 'bracket-loser'}`}>
                        <span className="bracket-seed">{teamData[player]?.seed}</span>
                        <span className="bracket-name">{player}</span>
                        <span className="bracket-score">{game[player]}</span>
                        {props?.winnerIcon && _isWinner && <i className={`${props.winnerIcon} ms-1`}></i>}
                    </div>
                }))}
            </div> 
        })
    };
    
    const getRoundClass = (roundName) => {
        const name = (roundName || '').toLowerCase();
        if (name.includes('championship')) return 'bracket-round-championship';
        if (name.includes('award') || name.includes('mcgrath')) return 'bracket-round-third-place';
        return '';
    };

    const buildPlayoffs = (playoffs) => {
        return (
            <div className="playoffs-bracket-container">
                <h4 className="mb-3">Playoffs</h4>
                {/* bracket-wrapper uses row-reverse so DOM order [Championship→Wildcard] displays
                    chronologically on desktop as Wildcard→Semifinals→3rd Place→Championship */}
                <div className="bracket-wrapper">
                    {playoffs.gameData.map((round, roundIndex) => (
                        <div key={`round-${roundIndex}`} className={`bracket-round ${getRoundClass(round.name)}`}>
                            <h5 className="bracket-round-title">{round.name}</h5>
                            <div className="bracket-games">
                                {getGameComponentFromGames(round.games, round.props, playoffs.teamData)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };
    
    const buildRegSeason = (regSeasonData) => {
        let regSeasonTableRows = regSeasonData.standings.map((teamResult, index) => {
            return (
                <tr key={`${yearName}-${teamResult.manager}`} className={teamResult.champ ? 'table-success' : teamResult.sacko ? 'table-danger' : ''}>
                    <th scope="row">{index + 1}</th>
                    <td>{teamResult.manager}</td>
                    <td>{teamResult.wins} - {teamResult.losses}</td>
                    <td>{teamResult.pf || '--'}</td>
                </tr>
            );
        });
    
        return (
            <div>
                <h4>Regular season</h4>
                <table className="table table-dark">
                    <thead>
                        <tr>
                            <th scope="col">Finish</th>
                            <th scope="col">Manager</th>
                            <th scope="col">Record</th>
                            <th scope="col">PF</th>
                        </tr>
                    </thead>
                    <tbody>
                        {regSeasonTableRows}
                    </tbody>
                </table>
            </div>
        )
    };
    
    const buildDraft = (draftData) => {
        let draftTableRows;
        if(!draftData.isAuction) {
            draftTableRows = draftData.picks.map((pick, index) => {
                let origPickManager = draftData.order[index % 12]
                return (
                    <tr key={`${yearName}-${pick.pick}`} className={Math.floor(index/12) % 2 ? 'table-secondary' : ''}>
                        <th scope="row">{Math.floor(index/12) + 1}.{index+1}</th>
                        <td><div style={{fontWeight: "bold"}}>{pick.manager}</div> {origPickManager !== pick.manager ? '(' + origPickManager + ')' : ''}</td>
                        <td>{pick.pick}</td>
                        {draftData.hasTimestamps && <td>{moment(pick.timestamp).format('MM-DD-YYYY hh:mm:ss a')}</td>}
                    </tr>
                );
            });
        } else {
            draftTableRows = draftData.picks.map((pick, index) => {
                return (
                    <tr className={Math.floor(index/17) % 2 ? 'table-secondary' : ''}>
                        <th scope="row">{pick.manager}</th>
                        <td><div style={{fontWeight: "bold"}}>{`$${pick.cost}`}</div></td>
                        <td>{`${pick.pick}`}</td>
                    </tr>
                );
            });
        }
        return (
            <div>
                <h4>Draft Results</h4>
                <div className="d-grid mx-auto">
                    <button className="btn btn-outline-info draft-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target={'#draft-table' + yearName} aria-expanded="false" aria-controls={'draft-table' + yearName}>
                        <i className="bi bi-chevron-down me-2"></i>
                        Show/Hide Draft Results
                        <i className="bi bi-list-ul ms-2"></i>
                    </button>
                </div>
                <div className="collapse" id={'draft-table' + yearName}>
                    <table className="draftTable table-dark table align-middle">
                        <thead>
                            <tr>
                                <th scope="col">{draftData.isAuction ? 'Manager' : 'Number'}</th>
                                <th scope="col">{draftData.isAuction ? 'Cost' : 'Manager'}</th>
                                <th scope="col">Pick</th>
                                {draftData.hasTimestamps && <th scope="col">Time</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {draftTableRows}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
    
    return (
        <div id={yearName + '-season'} key={yearName + '-season'} className="seasonContainer sectionContainer">
            <h3>{yearName} Season</h3>
            {seasonData.playoffs && buildPlayoffs(seasonData.playoffs)}
            {seasonData.regSeason && buildRegSeason(seasonData.regSeason)}
            {seasonData.draft && seasonData.draft?.picks?.length ? buildDraft(seasonData.draft) : <span><span className="badge bg-danger">!</span> Missing Draft Data</span>}
            {payouts.length && <SeasonPayouts payoutData={payouts}/> }
        </div>
    );
};

export default Season;